export default __webpack_public_path__ + "locales/sk/DeleteDialog.json?hash=2b8c43941504d7d439f57650cebc21d1";